import React from 'react'
import { motion } from 'framer-motion'
import { techStack } from '../../assets'
import { techStackImgs } from '../../utils/constants'
import './techStack.css'

const TechStack = () => {
  return (
    <>
      <section id='tech-stack' className='tech-stack-main-wrapper'>
        <h2>Tech Stack</h2>

        <div className='tech-stack-img-wrapper'>
          <div className='tech-stack-main-img'>
            <img src={techStack} alt='techStack' />
          </div>

          <div className='tech-stack-img-container'>
            {techStackImgs.map((result, index) => (
              <motion.div whileInView={{opacity: [0, 1]}} transition={{ duration: 3.5}} key={index} className='tech-stack-img-title-wrapper'>
                <div className='tech-stack-imgBx'>
                  <img src={result.image} alt={result.title} />
                </div>

                <span className='tech-stack-title'>
                  {result.title}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default TechStack